import type { ProcessSource } from "../../api/types";
import { parseUtcDate } from "../../utils";

export const processSourceInstanceKey = (source: ProcessSource): string =>
  `${source.recordingId}:${source.traceIndex}`;

const traceStartTime = (source: Pick<ProcessSource, "traceStart">): number =>
  parseUtcDate(source.traceStart).getTime();

export const compareProcessSourcesByStart = (
  a: Pick<ProcessSource, "recordingId" | "traceIndex" | "traceStart">,
  b: Pick<ProcessSource, "recordingId" | "traceIndex" | "traceStart">,
): number =>
  traceStartTime(a) - traceStartTime(b) ||
  a.recordingId.localeCompare(b.recordingId) ||
  a.traceIndex - b.traceIndex;

export const processRecordingInstanceNumbersBySourceKey = (
  sources: ProcessSource[],
): Map<string, number> => {
  const countsByRecording = new Map<string, number>();
  const numbersBySource = new Map<string, number>();

  for (const source of [...sources].sort(compareProcessSourcesByStart)) {
    const instanceNumber = (countsByRecording.get(source.recordingId) ?? 0) + 1;
    countsByRecording.set(source.recordingId, instanceNumber);
    numbersBySource.set(processSourceInstanceKey(source), instanceNumber);
  }

  return numbersBySource;
};

export const recordingAnalysisPath = (
  recordingId: string,
  processSlug: string,
  instanceNumber?: number,
): string => {
  const searchParams = new URLSearchParams();
  searchParams.set("process", processSlug);
  if (instanceNumber !== undefined) {
    searchParams.set("instance", String(instanceNumber));
  }
  return `/recordings/${encodeURIComponent(recordingId)}/?${searchParams.toString()}`;
};
